export default __webpack_public_path__ + "static/media/minibus.5dd3bf9b.png";